import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { Aggregate } from '../../base/ddd-types/aggregate';
import { changeSuperVipData, dataFieldNamingHandler, exceptionHandler, fireEvent, parseArrayData, parseHeaderKey2DataHandler, parseObjectData, } from '../../base/decorators';
import { UserInfo } from '../entity/user-info-entity';
import { UserInfoRepository } from '../repository/user-info-repository';
import { VipInfo } from '../value-object/vip-info';
import { Emitter } from '@tencent/ark-utils/lib/event';
// 用户信息更新事件名
var USERINFO_DID_UPDATE_EVENT_NAME = 'mOnUserInfoDidUpdated';
// 用户信息属性Key值
var USERINFO_PREPOTRY_KEY = 'userInfo';
// vipInfo属性Key值
var VIPINFO_PREPOTRY_KEY = 'vipInfo';
// vipInfo属性Key值
var USERINFO_ID = 'mainUserInfo';
// 返回的jsonObject数据字段
var JSONOBJECT_VIPINFO_PREPOTRY_KEY = 'vip_info';
/**
 * polling headers里的'x-u'属性名
 */
var PRASE_HEADER_KEY_X_U = 'x-u';
var RESDATA_KEY_X_U = 'xu';
var UserInfoAggregate = /** @class */ (function (_super) {
    __extends(UserInfoAggregate, _super);
    function UserInfoAggregate(id) {
        var _this = _super.call(this, id) || this;
        // userInfo信息值对象
        _this.userInfo = new UserInfo(USERINFO_ID);
        _this.mOnUserInfoDidUpdated = new Emitter();
        // 数据请求实体
        _this.userInfoRepository = new UserInfoRepository();
        _this.onUserInfoDidUpdated = _this.mOnUserInfoDidUpdated.event;
        return _this;
    }
    /**
     * cgi服务
     */
    UserInfoAggregate.prototype.fetchUserInfo = function (getVipInfo, u) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userInfoRepository.getUserInfo(getVipInfo, u)];
            });
        });
    };
    UserInfoAggregate.prototype.fetchVipInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 这条服务，拉取之前先清空
                this.vipInfo = [];
                return [2 /*return*/, this.userInfoRepository.getVipInfo()];
            });
        });
    };
    UserInfoAggregate.prototype.fetchUserFlag = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userInfoRepository.getUserFlag(type)];
            });
        });
    };
    UserInfoAggregate.prototype.userInfoCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userInfoRepository.userInfoCheck()];
            });
        });
    };
    __decorate([
        fireEvent(USERINFO_DID_UPDATE_EVENT_NAME, USERINFO_PREPOTRY_KEY),
        parseObjectData(UserInfo.prototype.constructor, USERINFO_PREPOTRY_KEY),
        changeSuperVipData(),
        exceptionHandler(),
        parseHeaderKey2DataHandler(PRASE_HEADER_KEY_X_U, RESDATA_KEY_X_U),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, String]),
        __metadata("design:returntype", Promise)
    ], UserInfoAggregate.prototype, "fetchUserInfo", null);
    __decorate([
        parseArrayData(VipInfo.prototype.constructor, VIPINFO_PREPOTRY_KEY, JSONOBJECT_VIPINFO_PREPOTRY_KEY),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], UserInfoAggregate.prototype, "fetchVipInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], UserInfoAggregate.prototype, "fetchUserFlag", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], UserInfoAggregate.prototype, "userInfoCheck", null);
    return UserInfoAggregate;
}(Aggregate));
export { UserInfoAggregate };
